import React, { useEffect, useState } from "react";
// import "./orderTable.css";
import "./table.css";
import styled from "@emotion/styled";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderRadius: "15px",

    maxWidth: "50rem",
    height: "32rem",
    overflowY: "scroll",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const UploadInvoiceTable = ({
  maxWidth = "60rem",
  orderProducts,
  invoices,
  updateInvoice,
}) => {
  return (
    <div className="">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table">
          <tr className="table-rows">
            <th className="table-heads text-dark " width={"2%"}>
              #
            </th>
            <th className="table-heads text-dark" width={"11%"}>
              Product Name
            </th>
            <th className="table-heads text-dark" width={"4%"}>
              Qty
            </th>
            <th className="table-heads text-dark" width={"4%"}>
              Free Qty
            </th>
            <th className="table-heads text-dark" width={"8%"}>
              Invoice Qty
            </th>
            <th className="table-heads text-dark" width={"8%"}>
              Invoice Free Qty
            </th>
          </tr>
          {invoices &&
            invoices.length > 0 &&
            invoices.map((ele, index) => (
              <tr className="table-rows1" key={ele.id}>
                <td className="table-each-row-data color_747f9e">
                  {index + 1}
                </td>
                <td className="table-each-row-data color_747f9e">
                  {ele?.product_name}
                </td>
                <td className="table-each-row-data color_747f9e">
                  {ele?.quantity}
                </td>
                <td className="table-each-row-data color_747f9e">
                  {ele?.offer_qty}
                </td>
                <td className="table-each-row-data color_747f9e">
                  {ele?.invoice_qty}
                </td>
                <td className="table-each-row-data color_747f9e">
                  {ele?.invoice_free_qty}
                </td>
              </tr>
            ))}
          {orderProducts?.length > 0 &&
            orderProducts.map((ele, index) => (
              <tr className="table-rows1" key={ele.id}>
                <td className="table-each-row-data color_747f9e">
                  {index + 1}
                </td>
                <td className="table-each-row-data color_747f9e">
                  {ele?.product?.product_name}
                </td>
                <td className="table-each-row-data color_747f9e">
                  {invoices.length > 0 ?
                    ele.quantity - invoices
                      .filter(o1 => o1.product_id === ele.id)
                      .reduce((totalQty, invoice) => totalQty + invoice.invoice_qty, 0)
                    : ele.quantity
                  }
                </td>
                <td className="table-each-row-data color_747f9e">
                  {invoices.length > 0 ?
                    ele.offer_qty - invoices
                      .filter(o1 => o1.product_id === ele.id)
                      .reduce((totalQty, invoice) => totalQty + invoice.invoice_free_qty, 0)
                    : ele?.offer_qty
                  }
                </td>
                <td className="table-each-row-data color_747f9e">
                  <input
                    type="number"
                    min={0}
                    className=" table-input px-2 py-1"
                    placeholder="Enter qty"
                    name="invoice_qty"
                    onChange={(e) => updateInvoice(e, ele)}
                  />
                </td>
                <td className="table-each-row-data color_747f9e">
                  <input
                    type="number"
                    className="table-input px-2 py-1"
                    min={0}
                    placeholder="Enter qty"
                    name="invoice_free_qty"
                    onChange={(e) => updateInvoice(e, ele)}
                    disabled={!ele?.offer}
                  />
                </td>
              </tr>
            ))}
        </table>
      </TableContainer>
    </div>
  );
};

export default UploadInvoiceTable;
